export default (cart) => ({
	event: 'virtualPageview',
	pageName: cart.page.tracking,
	cartLocale: cart.url.locale,
	isHotjarEnabled: cart.theme.tracking.hotjar,
	orderId: cart.order && cart.order.id,
	contentGroup: cart.order && cart.order.contentGroup
});
